<template>
    <collapsible-card :title="'Berth Information'" v-show="showInfo" ref="cCard">
        <div class="cardContent">
            <div v-if="general.length > 0" class="category">
                <h3 class="categoryTitle">General</h3>
                <div>
                    <div v-for="obj in general" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="location.length > 0" class="category">
                <h3 class="categoryTitle">Location</h3>
                <div>
                    <div v-for="obj in location" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="details.length > 0" class="category">
                <h3 class="categoryTitle">Details</h3>
                <div>
                    <div v-for="obj in details" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import {readFromObj} from '../../helpers/Formatting.js'
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "berth-info",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showInfo: false,
        general: [],
        location: [],
        details: [],
    }),
    methods: {
        updateInfo: function(berthInfoObj) {
            var globv = this;

            if (!(berthInfoObj && berthInfoObj instanceof Object && Object.keys(berthInfoObj).length > 0)) {
                return;
            }

            // console.log(JSON.stringify(berthInfoObj, undefined, 4));

            if (berthInfoObj['general']) {
                let expectedVariables = [
                    {
                        varName: "name",
                        fieldName: "Name"
                    },
                    {
                        varName: "owners",
                        fieldName: "Owner"
                    },
                    {
                        varName: "port",
                        fieldName: "Port"
                    },
                    {
                        varName: "bank",
                        fieldName: "Bank Side"
                    },
                    {
                        varName: "attachedHighway",
                        fieldName: "Attached Highway"
                    },
                    {
                        varName: "attachedRailway",
                        fieldName: "Attached Railway"
                    }
                ]
            
                globv.general = readFromObj(berthInfoObj['general'], expectedVariables);
            }

            if (berthInfoObj['location']) {
                globv.location.push({
                    field: "Latitude / Longitude",
                    val: berthInfoObj['location']['latitude'] + "° / " + berthInfoObj['location']['longitude'] + "°"
                })

                let expectedVariables = [
                    {
                        varName: "locode",
                        fieldName: "UN/LOCODE"
                    },
                    {
                        varName: "streetAddress",
                        fieldName: "Address"
                    },
                    {
                        varName: "city",
                        fieldName: "City"
                    },
                    {
                        varName: "county",
                        fieldName: "County"
                    },
                    {
                        varName: "state",
                        fieldName: "State"
                    },
                    {
                        varName: "zipcode",
                        fieldName: "Zipcode"
                    },
                    {
                        varName: "locationD",
                        fieldName: "Location Description"
                    }
                ]

                globv.location = globv.location.concat(readFromObj(berthInfoObj['location'], expectedVariables));
            }

            if (berthInfoObj['details']) {
                globv.details.push({
                    field: "Depth (Min / Max)",
                    val: berthInfoObj['details']['depthMin'] + "ft / " + berthInfoObj['details']['depthMax'] + "ft"
                });

                let expectedVariables = [
                    {
                        varName: "deckHeight",
                        fieldName: "Deck Height",
                        unit: " ft"
                    },
                    {
                        varName: "commodities",
                        fieldName: "Commodities"
                    },
                    {
                        varName: "construction",
                        fieldName: "Construction"
                    },
                    {
                        varName: "mechanical",
                        fieldName: "Mechanical"
                    },
                    {
                        varName: "remarks",
                        fieldName: "Remarks"
                    }
                ]

                globv.details = globv.details.concat(readFromObj(berthInfoObj['details'], expectedVariables));
            }
            
            globv.showInfo = globv.general.length + globv.details.length > 0;
            globv.$refs.cCard.adjustHeight();
        },
        reset: function() {
            var globv = this;
            globv.showInfo = false;
            globv.general = [];
            globv.location = [];
            globv.details = [];
        }
    }
}
</script>

<style lang="scss">
</style>